// import "/assets/css/login.css";
import FrontendLayout from "../../layouts/FrontendLayout";
import Helmet from "../../components/Helmet";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";

import api from "../../api/axiosInstance";
import Header from "../../components/FrontendHeader";

export default function FullPreview() {
  const API_URL = process.env.REACT_APP_API_URL;
  const [loading, setLoading] = useState(true);
  const [previewData, setPreviewData] = useState({});
  const [declaration, setDeclaration] = useState(false);
  const navigate = useNavigate();
  const FilePreviewRow = ({ label, fileUrl }) => {
    if (!fileUrl) {
      return (
        <tr>
          <th>{label}</th> <td>{fileUrl}</td>
        </tr>
      );
    }
    const isPdf = fileUrl.toLowerCase().endsWith(".pdf");

    return (
      <tr>
        <th>{label}</th>
        <td colSpan="3">
          {isPdf ? (
            <a
              href={fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              alt="pdf"
              style={{ textColor: "blue" }}
            >
              View PDF
            </a>
          ) : (
            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
              <img
                src={fileUrl}
                alt={label}
                width="80"
                style={{
                  cursor: "pointer",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                }}
              />
            </a>
          )}
        </td>
      </tr>
    );
  };
  useEffect(() => {
    const fetchPreviewData = async () => {
      try {
        const response = await api.get("/fetchPreviewData");
        setPreviewData(response.data.data);

        if (previewData.FORM_STATUS === '0' && previewData.FINAL_SUBMIT !== '1') {
          navigate("/personal");
        } else if (previewData.FORM_STATUS === '1' && previewData.FINAL_SUBMIT !== '1') {
          navigate("/upload");
        }
       
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchPreviewData();
  }, [API_URL]);

  const handleSubmit = async () => {
    if (!declaration) {
      toast.error("Kindly check the declaration");
      return;
    }
    try {
      setLoading(true);
      await api.post("/saveFinal");
      toast.success("Thank you! Your form has been successfully submitted.");
      setTimeout(() => navigate("/completed"), 1500);
    } catch (err) {
      toast.error(err.response?.data?.message || "Submission failed");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Helmet title="Preview" /> <FrontendLayout />
      {/* <div className="print-header">
        <Header />
      </div> */}
      <ToastContainer position="top-center" />
      {loading ? (
        <div className="full-page-loader">
          <ClipLoader size={60} />
        </div>
      ) : (
        <div className="main print-area">
          <div className="only-print-header">
            <Header />
          </div>
          <section className="container-fluid py-4" style={{ width: "95%" }}>
            <h4 className="text-center text-primary fw-bold mb-4">
              FINANCIAL SUPPORT SCHEME (FSS) 2026-27
            </h4>
            <div className="card shadow p-4 mb-4">
              <div className="no-print d-flex justify-content-end mb-3">
                <button
                  className="btn btn-success"
                  onClick={() => window.print()}
                >
                  Print Application
                </button>
              </div>
              <div
                className="table-responsive"
                style={{ WebkitOverflowScrolling: "touch" }}
              >
                <table className="table table-bordered mb-0">
                  <tbody>
                    <tr>
                      <th className="align-middle">Name</th>
                      <td className="align-middle">
                        {previewData.STUDENT_NAME}
                      </td>
                      <th className="align-middle">SOL Roll No.</th>
                      <td className="align-middle">
                        {previewData.SOL_ROLL_NO}
                      </td>
                      {previewData?.FSS_CODE && (
                        <>
                          <th className="align-middle">FSS Code</th>
                          <td className="align-middle">
                            {previewData.FSS_CODE}
                          </td>
                        </>
                      )}

                      <td className="text-center align-middle">
                        <a
                          href={previewData?.PHOTO}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ display: "inline-block" }}
                        >
                          <img
                            src={previewData?.PHOTO}
                            alt="Signature"
                            width="80"
                            style={{
                              cursor: "pointer",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                            }}
                          />
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="card shadow p-2 p-md-4 mb-4">
              <h5 className="text-center bg-primary text-white py-2 rounded mb-4">
                Personal Details
              </h5>
              <div
                className="table-responsive"
                style={{ WebkitOverflowScrolling: "touch" }}
              >
                <table className="table table-striped table-bordered ">
                  <tbody>
                    <tr>
                      <th>Student's Name</th>
                      <td>{previewData?.STUDENT_NAME || "N/A"}</td>
                      <th>SOL Roll Number</th>
                      <td>{previewData?.SOL_ROLL_NO || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Contact No.</th>
                      <td>{previewData?.MOBILE || "N/A"}</td>
                      <th>Programme</th>
                      <td>{previewData?.COURSE || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Admission Year</th>
                      <td>{previewData?.ADMISSION_YEAR || "N/A"}</td>
                      <th>Current semester</th>
                      <td>{previewData?.SEMESTER || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Aadhaar Number</th>
                      <td>{previewData?.STUDENT_ADHAR_NO || "N/A"}</td>
                      <th>PAN Number</th>
                      <td>{previewData?.STUDENT_PAN_NO || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Bank Holder Name</th>
                      <td>{previewData?.BANK_HOLDER_NAME || "N/A"}</td>
                      <th>Bank Account Number</th>
                      <td>{previewData?.STUDENT_BANK_ACC || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Bank IFSC</th>
                      <td>{previewData?.BANK_IFSC_CODE || "N/A"}</td>
                      <th>Bank Name</th>
                      <td>{previewData?.STUDENT_BANK_NAME || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Father's Name</th>
                      <td>{previewData?.FATHER_NAME || "N/A"}</td>
                      <th>Father's Occupation</th>
                      <td>{previewData?.FATHER_TYPE_OF_JOB || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Father's Annual Income</th>
                      <td>{previewData?.FATHER_ANNUAL_INCOME || "N/A"}</td>
                      <th>Father's PAN</th>
                      <td>{previewData?.FATHER_PAN_NO || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Father's ITR Value</th>
                      <td>{previewData?.FATHER_ITR || "N/A"}</td>
                      <th>Mother's Name</th>
                      <td>{previewData?.MOTHER_NAME || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Mother's Occupation</th>
                      <td>{previewData?.MOTHER_TYPE_OF_JOB || "N/A"}</td>
                      <th>Mother's Annual Income</th>
                      <td>{previewData?.MOTHER_ANNUAL_INCOME || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Mother's PAN</th>
                      <td>{previewData?.MOTHER_PAN_NO || "N/A"}</td>
                      <th>Mother's ITR Value</th>
                      <td>{previewData?.MOTHER_ITR || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Total Annual Family Income</th>
                      <td>{previewData?.TOTAL_FAMILY_INCOME || "N/A"}</td>
                      <th>Total Annual Family Income Lies Between</th>
                      <td>{previewData?.INCOME_LIES_BETWEEN || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>No. of Dependent Family Members</th>
                      <td>{previewData?.DEPENDENT_MEMBER || "N/A"}</td>
                      <th>Income Certificate No</th>
                      <td>{previewData?.INCOME_CERTIFICATE_NO || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Income Certificate Issued By</th>
                      <td>{previewData?.INCOME_ISSUED_BY || "N/A"}</td>
                      <th>Income Certificate Issued Date</th>
                      <td>
                        {new Date(
                          previewData?.INCOME_ISSUE_DATE,
                        ).toLocaleDateString("en-IN")}
                      </td>
                    </tr>
                    {previewData.RATION_CARD_NAME && (
                    <>
                    <tr>
                      <th>Ration Card Name</th>
                      <td>{previewData?.RATION_CARD_NAME || "N/A"}</td>
                      <th>Ration Card Issued By</th>
                      <td>{previewData?.RATION_ISSUED_BY || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>Ration Card Issued Date</th>
                      <td colSpan="3">
                        {previewData?.RATION_ISSUE_DATE
                          ? new Date(
                              previewData.RATION_ISSUE_DATE,
                            ).toLocaleDateString("en-IN")
                          : "N/A"}
                      </td>
                    </tr>
                    </>
                  )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="card shadow p-4 mb-4">
              <h5 className="text-center bg-primary text-white py-2 rounded mb-4">
                Upload Details
              </h5>
              <table className="table table-striped table-bordered">
                <tbody>
                  <FilePreviewRow label="Photo" fileUrl={previewData?.PHOTO} />
                  <FilePreviewRow
                    label="Signature"
                    fileUrl={previewData?.SIGNATURE}
                  />
                  <FilePreviewRow
                    label="Latest Fee Receipt"
                    fileUrl={previewData?.FEE_RECEIPT}
                  />
                  <FilePreviewRow
                    label="Family Income Certificate (Issued after 31/03/2026)"
                    fileUrl={previewData?.INCOME_CERTIFICATE}
                  />
                  {previewData?.RATION_CARD && (
                    <FilePreviewRow
                      label="Ration Card"
                      fileUrl={previewData?.RATION_CARD}
                    />
                  )}
                  <FilePreviewRow
                    label="Bank Passbook/Leaf of Cheque"
                    fileUrl={previewData?.BANK_PASSBOOK}
                  />
                  {previewData?.FINAL_YEAR_MARKSHEET && (
                    <FilePreviewRow
                      label="Latest Marksheet"
                      fileUrl={previewData?.FINAL_YEAR_MARKSHEET}
                    />
                  )}
                  <FilePreviewRow
                    // label="Affidavit of
                    //   Unemployment / Employment / Self-Employment (Notary
                    //   Attested)"
                    label="Undertaking for Employment Status (Employed / Unemployed / Self-Employed)"
                    fileUrl={previewData?.UNEMPLOYEMENT_DECLARATION}
                  />
                </tbody>
              </table>
            </div>
            <div className="card shadow p-4 mb-4">
              <h5 className="text-center bg-primary text-white py-2 rounded mb-4">
                Declaration
              </h5>
              <div className="form-check mb-4">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="declarationCheck"
                  disabled={previewData.FINAL_SUBMIT === '1'}
                  checked={previewData.FINAL_SUBMIT === '1' || declaration}
                  onChange={(e) => setDeclaration(e.target.checked)}
                  required
                />
                <label
                  disabled
                  className="form-check-label text-dark fw-semibold "
                  htmlFor="declarationCheck"
                  style={{ textAlign: "justify" }}
                >
                  I hereby declare that all the information furnished by me in
                  this application form for the Financial Support Scheme (FSS)
                  2026-27 is true, complete, and correct to the best of my
                  knowledge and belief. I have carefully read and understood the
                  guidelines of the scheme and confirm that I fulfill all the
                  eligibility criteria prescribed. I further declare that the
                  documents uploaded by me are genuine and authentic. I
                  understand that if any information or document provided by me
                  is found to be false, incorrect, or misleading at any stage,
                  my application is liable to be rejected, and I may be
                  subjected to appropriate legal or disciplinary action as per
                  the rules of the concerned authority. I also undertake to
                  inform the concerned authority immediately in case of any
                  change in the information provided by me in this application.
                </label>
              </div>
              <div className="d-flex justify-content-end align-items-center mb-3">
                <div className="text-center">
                  <a
                    href={previewData?.SIGNATURE}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={previewData?.SIGNATURE}
                      alt="Signature"
                      width="100"
                      style={{
                        cursor: "pointer",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "4px",
                        background: "#fff",
                      }}
                    />
                  </a>
                  <div className="small text-muted mt-1">
                    {previewData.STUDENT_NAME}
                  </div>
                </div>
              </div>
              {previewData.FINAL_SUBMIT !== '1' && (
                <div className="d-flex no-print">
                  <button
                    type="button"
                    className="btn btn-warning px-4 w-50"
                    onClick={() => navigate("/upload")}
                  >
                    Previous
                  </button>
                  <button
                    type="submit"
                    className="btn btn-success px-4 w-50"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              )}
            </div>
          </section>
        </div>
      )}
    </>
  );
}
